import axios from '@/utils/axios';

/**
 * 支付接口
*/
export function toPay(parameter) {
  return axios.formRequest.post('pay/pay/pay', parameter);
}

/**
 * 协议接口
 */
export function getAgreement() {
  return axios.formRequest.post('pay/pay/get_agreement', {});
}

/**
 * 验证邀请码
 */
export function checkInvitationCode(invitation_code) {
  return axios.formRequest.post('pay/pay/check_invitation_code', { invitation_code });
}

/**
 * 验证支付
 */
export function checkOrder(order_id) {
  return axios.formRequest.post('pay/pay/check_order', { order_id });
}

/**
 * 获取图片
 */
export function getPng(url) {
  return axios.formRequest.post('pay/pay/png', { url });
}
